import {Component, inject, Input, OnInit} from '@angular/core';
import {SuperObjectModel} from "../../../core/definitions/super-object-model";
import {DateToolsService} from "../../../core/date-tools.service";

@Component({
    selector: 'app-identification-number-log',
    templateUrl: './identification-number-log.component.html',
    styleUrls: ['./identification-number-log.component.scss'],
    standalone: false
})
export class IdentificationNumberLogComponent implements OnInit {
  // Injections
  private readonly dateTools: DateToolsService = inject(DateToolsService);

  @Input() object: SuperObjectModel;

  logItems: any[] = [];

  ngOnInit(): void {
    const logData = this.object.identification_number_log || [];
    this.logItems = logData.map(item => {
      return {
        updated_at: this.dateTools.isoDateToString(item.updated_at),
        updated_by: item.updated_by_id_value,
        to_identification_number: item.to_identification_number,
        from_identification_number: item.from_identification_number
      }
    });
  }

  displayedColumns = ['updated_at', 'updated_by', 'to_identification_number', 'from_identification_number'];

}
